// extracted by mini-css-extract-plugin
export var container = "_rr-0";
export var table = "_rr-2";
export var tableWrapper = "_rr-1";